import { EnterpriseManningVesselsService } from "../master";

const VesselRolePositonAssignableService = (() => {
  const createVesselRolePositionSelectable = (
    assignableVessels,
    vesselsData
  ) => {
    const selectableList = [];

    // vesselsData.manning_vesselsが存在しない場合は空の配列を返す
    if (!vesselsData || !vesselsData.manning_vessels) {
      return selectableList;
    }

    assignableVessels.vessels.forEach(assignableVessel => {
      // 該当するVesselを見つける
      const vessel = vesselsData.manning_vessels.find(
        v => v.id === assignableVessel.id
      );
      if (!vessel) {
        return; // 見つからなければスキップ
      }

      const positionIds = assignableVessel.roles.flatMap(
        role => role.position_ids || []
      );

      const rolePositions = positionIds
        .map(positionId => {
          const position = EnterpriseManningVesselsService.findRolePositionById(
            positionId
          );
          // positionが見つからない場合はnullを返すことで後でフィルタリングできる
          return position ? { value: positionId, text: position.name } : null;
        })
        .filter(Boolean); // nullを除去

      // Role Positionsが空の場合はスキップ
      if (rolePositions.length === 0) {
        return;
      }

      // 結果を追加
      selectableList.push({
        vessel: { value: vessel.id, text: vessel.name },
        rolePositions: rolePositions,
      });
    });
    return selectableList;
  };
  return {
    createVesselRolePositionSelectable,
  };
})();

export { VesselRolePositonAssignableService };
